/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';

@Injectable()
/** this menu service is created to
 * setup the menu item using config service
 *  configuration
  **/
export class LmsMenuService {
    private menuItems;
    private configData;

    /**
     * Creates an instance of LmsMenuService.
     * Also Created Menu Items List
     * @param {ConfigService} configService
     * @memberOf LmsMenuService
     */
    constructor(private configService: ConfigService) {
        this.configData = this.configService.getConfigData();
        this.menuItems = [
            {
                type: this.configData.menu.type.terminal,
                tabSupported: true,
                iconPath: this.configData.images.menuIcon.white.terminalIcon,
                subTypes: [this.configData.menu.subType.status, this.configData.menu.subType.handling, this.configData.menu.subType.notes],
                defaultSubType: this.configData.menu.subType.status,
                url: this.configData.menu.url.terminal,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'
            },
            {
                type: this.configData.menu.type.locomotive,
                tabSupported: true,
                iconPath: this.configData.images.menuIcon.white.locomotiveIcon,
                subTypes: [this.configData.menu.subType.data, this.configData.menu.subType.history, this.configData.menu.subType.notes],
                defaultSubType: this.configData.menu.subType.data,
                url: this.configData.menu.url.locomotive,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'
            },
            {
                type: this.configData.menu.type.train,
                tabSupported: true,
                iconPath: this.configData.images.menuIcon.white.trainIcon,
                subTypes: [this.configData.menu.subType.data,
                this.configData.menu.subType.profile,
                this.configData.menu.subType.history,
                this.configData.menu.subType.notes],
                defaultSubType: this.configData.menu.subType.data,
                url: this.configData.menu.url.train,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'
            },
            {
                type: this.configData.menu.type.locoStatus,
                tabSupported: true,
                iconPath: this.configData.images.menuIcon.white.locomotiveStatus,
                subTypes: [this.configData.menu.subType.data],
                defaultSubType: this.configData.menu.subType.data,
                url: this.configData.menu.url.locoStatus,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'
            },
            {
                type: this.configData.menu.type.yardLocal,
                tabSupported: true,
                iconPath: this.configData.images.menuIcon.white.yardNLocal,
                subTypes: [this.configData.menu.subType.data],
                url: this.configData.menu.url.yardLocal,
                defaultSubType: this.configData.menu.subType.data,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'

            },
            {
                type: this.configData.menu.type.outlyingPoints,
                tabSupported: true,
                iconPath: this.configData.images.menuIcon.white.outlyingPoints,
                subTypes: [this.configData.menu.subType.data],
                defaultSubType: this.configData.menu.subType.data,
                url: this.configData.menu.url.outlyingPoints,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'

            },  
            {
                type: this.configData.menu.type.queryView,
                tabSupported: true,
                iconPath: this.configData.images.menuIcon.white.search,
                subTypes: [this.configData.menu.subType.data],
                defaultSubType: this.configData.menu.subType.data,
                url: this.configData.menu.url.queryView,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'
            },               

            {
                type: this.configData.menu.type.tonnageRating,
                tabSupported: false,
                iconPath: this.configData.images.menuIcon.white.tonnageRatingIcon,
                subTypes: [this.configData.menu.subType.data],
                defaultSubType: this.configData.menu.subType.data,
                url: this.configData.menu.url.tonnageRating,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'
            },
            {
                type: this.configData.menu.type.help,
                tabSupported: false,
                iconPath: this.configData.images.menuIcon.white.help,
                subTypes: [this.configData.menu.subType.data],
                defaultSubType: this.configData.menu.subType.data,             
                url: this.configData.menu.url.help,
                helpUrl: 'https://wiki.csx.com/display/HC/LMS'               
            },
            {
                type: this.configData.menu.type.listManager,
                tabSupported: false,
                iconPath: this.configData.images.menuIcon.white.listManager,
                url: this.configData.menu.url.listManager,
            }, 
            // {
            //     type: this.configData.menu.type.phonebook,
            //     tabSupported: false,
            //     iconPath: this.configData.images.menuIcon.white.phonebook,
            //     url: this.configData.menu.url.phonebook,
            // },
            {
                type: this.configData.menu.type.terminalHelp,
                tabSupported: false,
                iconPath: this.configData.images.menuIcon.white.terminalHelp,
                url: this.configData.menu.url.terminalHelp,
                showOnly: this.configData.menu.url.terminal
            }
        ];
    }

    /**
     * This method is used to get Menu Items
     * @returns
     * @memberOf LmsMenuService
     */
    getMenuItems() {
        return this.menuItems;
    }

    /**
     * This is used to get Menu item from List of Menu items
     * @param {string} type
     * @returns
     * @memberOf LmsMenuService
     */
    getMenuItem(type: string) {
        return this.getMenuItems().find(data => { return type === data.type; });
    }
}
